// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showCover = function (this: any) {
  const board = this.model.getBoard();
  return (
    // Assume board is nullable since it can't be retrieved sometimes
    board?.getPref('cardCovers') && this.model.hasCover() && !this.onCalendar
  );
};
